module.exports = __webpack_public_path__ + "static/sun_image-e33a32da97b985a978c1b239a61b4da8.png";